export default __webpack_public_path__ + "static/media/kedhu.0df585c0.jpg";